/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _settings = require('../settings');

var _settings2 = _interopRequireDefault(_settings);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

/*
* This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
* See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
*
* Remove it at your own risk.
*/

var ApiClient_ = (function () {
	function ApiClient_(req) {
		var _this = this;

		_classCallCheck(this, ApiClient_);

		['get', 'post', 'put', 'patch', 'del'].forEach(function (method) {
			_this[method] = function (path, options) {
				return new _Promise(function (resolve, reject) {
					var url = _this.formatUrl(path);
					var request = _superagent2['default'][method](url);

					if (options && options.params) {
						request.query(options.params);
					}

					if (options && options.token) {
						request.set('authorization', 'Bearer ' + options.token);
					}

					if (__SERVER__) {
						if (req.get('cookie')) {
							request.set('cookie', req.get('cookie'));
						}
					}

					if (options && options.data) {
						request.send(options.data);
					}
					request.end(function (err, res) {
						if (err) {
							reject(res && res.body || err);
						} else {
							resolve(res.body);
						}
					});
				});
			};
		});
	}

	/* This was originally a standalone function outside of this class, but babel kept breaking, and this fixes it  */

	ApiClient_.prototype.formatUrl = function formatUrl(path) {
		var adjustedPath = path[0] !== '/' ? '/' + path : path;
		var fullPath = _settings2['default'].protocol + ':' + _settings2['default'].cdn + 'wp-json' + adjustedPath;
		return fullPath;
	};

	return ApiClient_;
})();

var ApiClient = ApiClient_;
exports['default'] = ApiClient;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/ApiClient.js
 ** module id = 713
 ** module chunks = 0
 **/